<app-page-topbar [title]="'Performance'" [menu]="">
    @if (showExportButton$ | async) {
        <ng-container>
            <div *appDesktop class="button" (click)="onExportInsights()">
                <span>Export Insights</span>
                <img src="/assets/icon/icon-export-pdf-arrow.svg" alt="Export" />
            </div>
        </ng-container>
    }

    <ng-container nav-tabs>
        @if (navTabs$ | async; as navTabs) {
            <app-nav-tabs [navTabs]="navTabs"></app-nav-tabs>
        }
    </ng-container>

</app-page-topbar>

<router-outlet></router-outlet>
